import React from "react";

import classnames from "classnames";

import { Span } from "Common/HTML";
import { type CarrierLogoProps } from "Theme/CarrierLogo";

import makeBem from "Utils/makeBem";

const bem = makeBem("CobaltCarrierLogo");
export const CarrierLogo = ({ plan, className, ...rest }: CarrierLogoProps) => (
  <Span className={classnames(bem(), className)} {...rest}>
    <img src={plan.carrier_logo} title={plan.carrier} alt={plan.carrier} />
  </Span>
);
export default CarrierLogo;
